<script setup lang="ts">
const { length = 0, placeholder = '' } = defineProps<{
    length?: number
    placeholder?: string
}>()

const shouldHideChar = (index: number): boolean => {
    return index < length || (index === length && length === placeholder.length - 1)
}
</script>

<template>
    <div class="placeholder">
        <span
            v-for="(char, index) in placeholder"
            :key="index"
            class="placeholder__char"
            :class="{ _hidden: shouldHideChar(index) }"
            :aria-hidden="shouldHideChar(index)"
        >
            {{ char === ' ' ? '&nbsp;' : char }}
        </span>
    </div>
</template>

<style lang="scss" scoped src="./VPlaceholder.scss"></style>
